import { render, staticRenderFns } from "./vFormPDF.vue?vue&type=template&id=0a24d710&scoped=true&"
import script from "./vFormPDF.vue?vue&type=script&lang=js&"
export * from "./vFormPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24d710",
  null
  
)

export default component.exports